import { FC } from "react";
import { Box, Typography } from "@mui/material";

import { formatDisplayDate } from "../../../../helpers/dataHelper";
import { getCardSx } from "../ediCardStyles";

// Stands in for a letter the claim is flagged as having, but no chat can account for
const AppealLetterPlaceholderCard: FC<{ billingDate?: string }> = ({
  billingDate,
}) => (
  <Box
    sx={{
      ...getCardSx("custom.cardBorder"),
      cursor: "default",
      backgroundColor: "grey.50",
      "&:hover": {},
    }}
  >
    <Box sx={{ minWidth: 0 }}>
      <Typography
        sx={{ fontSize: "0.8125rem", fontWeight: 600, color: "text.secondary" }}
      >
        Appeal letter (not available)
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ fontSize: "0.7rem" }}
      >
        Billed {formatDisplayDate(billingDate)}
      </Typography>
    </Box>
  </Box>
);

export default AppealLetterPlaceholderCard;
